import { useState, useEffect } from 'react'
import { db } from '../lib/supabase'

export default function ProtectedPublicRoute({ children, pageName }) {
  const [loading, setLoading] = useState(true)
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    checkVisibility()
  }, [pageName])

  const checkVisibility = async () => {
    try {
      const { visible } = await db.getPageVisibility(pageName)
      setIsVisible(visible)
    } catch (error) {
      console.error('Error checking page visibility:', error)
      setIsVisible(true) // Default to visible on error
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        flexDirection: 'column',
        gap: '1rem'
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '4px solid #f3f4f6',
          borderTop: '4px solid #3675CF',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        <p style={{ color: '#6b7280' }}>Cargando...</p>
      </div>
    )
  }

  if (!isVisible) {
    return (
      <div style={{
        maxWidth: '672px',
        margin: '4rem auto',
        padding: '0 2rem'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #FEF3C7 0%, #FDE047 100%)',
          border: '1px solid #FBBF24',
          borderRadius: '12px',
          padding: '2rem',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '4rem',
            marginBottom: '1rem'
          }}>⚠️</div>
          <h1 style={{
            fontSize: '1.875rem',
            fontWeight: '700',
            fontFamily: 'var(--font-display)',
            color: '#78350F',
            marginBottom: '0.75rem'
          }}>
            Página Temporalmente No Disponible
          </h1>
          <p style={{
            fontSize: '1rem',
            fontFamily: 'var(--font-ui)',
            color: '#92400E',
            marginBottom: '1.5rem',
            lineHeight: '1.6'
          }}>
            Esta página no está disponible en este momento. Por favor, regresa más tarde o contáctanos si necesitas asistencia.
          </p>
          <a
            href="/"
            style={{
              display: 'inline-block',
              padding: '0.875rem 2rem',
              background: '#78350F',
              color: 'white',
              border: 'none',
              borderRadius: '9999px',
              fontSize: '1rem',
              fontWeight: '600',
              fontFamily: 'var(--font-ui)',
              textDecoration: 'none',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#92400E'
              e.currentTarget.style.transform = 'translateY(-2px)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#78350F'
              e.currentTarget.style.transform = 'translateY(0)'
            }}
          >
            Volver al Inicio
          </a>
        </div>
      </div>
    )
  }

  return children
}
